import styled from "styled-components";

export const JackpotBetWidgetGamesListContainerDefaultBox = styled.div<{shouldHaveNoBackground?: boolean}>`
  display: flex;
  flex-direction: column;
  text-align: center;
  background: ${props => props.shouldHaveNoBackground ? "initial" : "#19003980"};
  font-size: 1.4em;
  flex: 1 1 auto;
  padding-bottom: 100px;
`;
